import { render, staticRenderFns } from "./prevencion-emergencias-editar.vue?vue&type=template&id=6a022c31&scoped=true&"
import script from "./prevencion-emergencias-editar.vue?vue&type=script&lang=js&"
export * from "./prevencion-emergencias-editar.vue?vue&type=script&lang=js&"
import style0 from "./prevencion-emergencias-editar.vue?vue&type=style&index=0&id=6a022c31&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a022c31",
  null
  
)

export default component.exports